import { createSlice } from '@reduxjs/toolkit';

const initialState = {
 isShown : true,
 link: "",
}

export const showpowerbiSlice = createSlice({
  name: 'showpowerbi',
  initialState,
  reducers: {
    UpdateShowPowerbi: (state, action) => {
        let data = action.payload;
        state.isShown = data.isShown;
        state.link = data.link;
    },
  },
})

// Action creators are generated for each case reducer function
export const { UpdateShowPowerbi } = showpowerbiSlice.actions;

export default showpowerbiSlice.reducer